import { COMMON_BOOLEAN_LABEL_MAP_2 } from '@components/ProjectFromComponents/data';

const SALESFEED_COLUMNS = [
  {
    title: '是否已知项目',
    dataIndex: 'coverageStatus',
    key: 'coverageStatus',
    render: (record: any) => {
      return record.coverageStatus == null
        ? ''
        : record.coverageStatus
        ? '否'
        : '是';
    }
  },
  {
    title: '产品线',
    dataIndex: 'projectProductLineKeyNameStr',
    key: 'projectProductLineKeyNameStr',
    render: (record: any) => {
      return record.projectProductLineKeyNameStr?.replace(/-/g, '/');
    }
  },
  {
    title: '品牌',
    dataIndex: 'projectBrandValueStr',
    key: 'projectBrandValueStr',
    render: (record: any) => {
      return record.projectBrandValueStr?.replace(/-/g, '/');
    }
  },
  {
    title: '型号',
    dataIndex: 'projectModelValueStr',
    key: 'projectModelValueStr',
    render: (record: any) => {
      return record.projectModelValueStr?.replace(/-/g, '/');
    }
  },
  {
    title: 'A/B/C Class',
    dataIndex: 'classTypeValue',
    key: 'classTypeValue',
    render: (record: any) => {
      return record.classTypeValue?.replace(/-/g, '/');
    }
  },
  {
    title: '主要配置',
    dataIndex: 'mainConfig',
    key: 'mainConfig'
  },
  {
    title: '是否有Opportunity ID',
    dataIndex: 'opportunityStatus',
    key: 'opportunityStatus',
    render: (record: any) => {
      return record.opportunityStatus == null
        ? ''
        : record.opportunityStatus
        ? '否'
        : '是';
    }
  },
  {
    title: '是否创建Leads',
    dataIndex: 'createLeads',
    key: 'createLeads',
    render: (record: any) => {
      return COMMON_BOOLEAN_LABEL_MAP_2[record.createLeads] || '';
    }
  },
  {
    title: '是否为大规模设备更新',
    dataIndex: 'lerStatus',
    key: 'lerStatus',
    render: (record: any) => {
      return record.lerStatus == null ? '' : record.lerStatus ? '否' : '是';
    }
  },
  {
    title: '线下表格',
    dataIndex: 'offlineFormValue',
    key: 'offlineFormValue'
  },
  {
    title: '表格ID',
    dataIndex: 'offlineFormId',
    key: 'offlineFormId'
  },
  {
    title: '是否参与招投标',
    dataIndex: 'attendTenderStatus',
    key: 'attendTenderStatus',
    render: (record: any) => {
      return record.attendTenderStatus == null
        ? ''
        : record.attendTenderStatus
        ? '否'
        : '是';
    }
  },
  {
    title: '赢单/输单',
    dataIndex: 'loseWinStatus',
    key: 'loseWinStatus',
    render: (record: any) => {
      return record.loseWinStatus == null
        ? ''
        : record.loseWinStatus === 1
        ? '赢单'
        : '输单';
    }
  },
  {
    title: '赢/输单原因',
    dataIndex: 'coreLoseReasonStatus',
    key: 'coreLoseReasonStatus',
    special: 'reason'
  },
  {
    title: '是否为老客户',
    dataIndex: 'oldCustomerStatus',
    key: 'oldCustomerStatus',
    render: (record: any) => {
      return record.oldCustomerStatus == null
        ? ''
        : record.oldCustomerStatus
        ? '否'
        : '是';
    }
  },
  {
    title: '负责的销售',
    dataIndex: 'subjectMatterProjectSaleName',
    key: 'subjectMatterProjectSaleName'
  },
  {
    title: '负责的经销商',
    dataIndex: 'corpName',
    key: 'corpName'
  },
  {
    title: '负责的经销商销售',
    dataIndex: 'dealerUserName',
    key: 'dealerUserName'
  },
  {
    title: 'Leads ID',
    dataIndex: 'LeadsIds',
    key: 'LeadsIds',
    render: (record: any) => {
      return record?.leadsData?.join();
    }
  }
];

const SALESFEED_COLUMNS_WAIT = [
  {
    title: '是否已知项目',
    dataIndex: 'coverageStatus',
    key: 'coverageStatus',
    render: (record: any) => {
      return record.coverageStatus == null
        ? ''
        : record.coverageStatus
        ? '否'
        : '是';
    }
  },
  {
    title: '产品线',
    dataIndex: 'projectProductLineKeyNameStr',
    key: 'projectProductLineKeyNameStr',
    render: (record: any) => {
      return record.projectProductLineKeyNameStr?.replace(/-/g, '/');
    }
  },
  {
    title: '品牌',
    dataIndex: 'projectBrandValueStr',
    key: 'projectBrandValueStr',
    render: (record: any) => {
      return record.projectBrandValueStr?.replace(/-/g, '/');
    }
  },
  {
    title: '型号',
    dataIndex: 'projectModelValueStr',
    key: 'projectModelValueStr',
    render: (record: any) => {
      return record.projectModelValueStr?.replace(/-/g, '/');
    }
  },
  {
    title: 'A/B/C Class',
    dataIndex: 'classTypeValue',
    key: 'classTypeValue',
    render: (record: any) => {
      return record.classTypeValue?.replace(/-/g, '/');
    }
  },
  {
    title: '主要配置',
    dataIndex: 'mainConfig',
    key: 'mainConfig'
  },
  {
    title: '是否有Opportunity ID',
    dataIndex: 'opportunityStatus',
    key: 'opportunityStatus',
    render: (record: any) => {
      return record.opportunityStatus == null
        ? ''
        : record.opportunityStatus
        ? '否'
        : '是';
    }
  },
  {
    title: '是否创建Leads',
    dataIndex: 'createLeads',
    key: 'createLeads',
    render: (record: any) => {
      return COMMON_BOOLEAN_LABEL_MAP_2[record.createLeads] || '';
    }
  },
  {
    title: '是否为大规模设备更新',
    dataIndex: 'lerStatus',
    key: 'lerStatus',
    render: (record: any) => {
      return record.lerStatus == null ? '' : record.lerStatus ? '否' : '是';
    }
  },
  {
    title: '线下表格',
    dataIndex: 'offlineFormValue',
    key: 'offlineFormValue'
  },
  {
    title: '表格ID',
    dataIndex: 'offlineFormId',
    key: 'offlineFormId'
  },
  {
    title: '负责的销售',
    dataIndex: 'subjectMatterProjectSaleName',
    key: 'subjectMatterProjectSaleName'
  },
  {
    title: '负责的经销商',
    dataIndex: 'corpName',
    key: 'corpName'
  },
  {
    title: '负责的经销商销售',
    dataIndex: 'dealerUserName',
    key: 'dealerUserName'
  },
  {
    title: 'Leads ID',
    dataIndex: 'LeadsIds',
    key: 'LeadsIds',
    render: (record: any) => {
      return record?.leadsData?.join();
    }
  }
];

export enum BiddingStatus {
  'EndBidding' = 12
}

export { SALESFEED_COLUMNS, SALESFEED_COLUMNS_WAIT };
